import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTransporter() {
    let transporterDetails = {
      reg_date: $(".reg_date").val(),
      transporter_name: $(".transporter_name").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val(),
      contact_person: $(".contact_person").val(),
      pin_no: $(".pin_no").val()
    };
    $(".creatingTransporter").hide();
    $(".creatingTransporterLoader").show();
    baseurl.post(rt.newTransporters, transporterDetails).then(res => {
      $(".creatingTransporter").show();
      $(".creatingTransporterLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.transporterCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //transporter exists
        ers.TransporterExists();
      } else if (res.data.code === 404) {
        //error on creating transporter
        ers.errorCreatingTransporter();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        setTimeout(() => {
          router.push("/dashboard");
        }, 200);
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadTransporters({ commit }) {
    baseurl.get(rt.loadTransporters).then(res => {
      $(".transportersLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_TRANSPORTERS", res.data.transporters);
      } else if (res.data.code === 404) {
        //error on loading transporters data
        ers.errorLoadingTransporters();
      } else if (res.data.code === 405) {
        //no permission to read data
        commit("STORE_TRANSPORTERS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  viewTransporter({ commit }, transporterId) {
    commit("STORE_TRANSPORTER_UPDATE", transporterId);
    router.push("/updatetransporter");
  },
  viewTransportertruck({ commit }, transporterId) {
    commit("STORE_TRANSPORTER_UPDATE", transporterId);
    router.push("/newTransportertruck");
  },

  transporterUpdate({ commit }) {
    let transporterDetail = {
      id: $(".id").val(),
      reg_date: $(".reg_date").val(),
      transporter_name: $(".transporter_name").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val(),
      contact_person: $(".contact_person").val(),
      pin_no: $(".pin_no").val()
    };
    $(".updatingTransporter").hide();
    $(".updatingTransporterLoader").show();
    baseurl.post(rt.updateTransporter, transporterDetail).then(res => {
      $(".updatingTransporter").show();
      $(".updatingTransporterLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.transporterUpdateSuccess();
        commit("STORE_TRANSPORTERS", res.data.transporters);
        setTimeout(() => {
          router.push("/managetransporters");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updatin transporter record
        ers.errorUpdatingTransporter();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/transporters/actions.js